var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('company-profile'),_c('reason'),_c('products'),_c('brand')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_top"},[_c('div',{staticClass:"home_top_img"}),_c('div',{staticClass:"home_top_bar"})])
}]

export { render, staticRenderFns }